var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.175 11.575L9.275 7.675C9.09167 7.49167 9 7.25833 9 6.975C9 6.69167 9.09167 6.45833 9.275 6.275C9.45833 6.09167 9.69167 6 9.975 6C10.2583 6 10.4917 6.09167 10.675 6.275L15.275 10.875C15.375 10.975 15.4458 11.0833 15.4875 11.2C15.5292 11.3167 15.55 11.4417 15.55 11.575C15.55 11.7083 15.5292 11.8333 15.4875 11.95C15.4458 12.0667 15.375 12.175 15.275 12.275L10.675 16.875C10.4917 17.0583 10.2583 17.15 9.975 17.15C9.69167 17.15 9.45833 17.0583 9.275 16.875C9.09167 16.6917 9 16.4583 9 16.175C9 15.8917 9.09167 15.6583 9.275 15.475L13.175 11.575Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.ccd945da49789f2ea425a62bdafb6fbb.svg";
export { ForwardRef as ReactComponent };